<template>
    <show-admins ref="registerAdmin" v-bind:is-me="false" v-bind:is-deps="true" v-bind:title="'Εμφάνιση Διαχειριστών ΔΕΠΣ'" />
</template>

<script>
import ShowAdmins from "../components/ShowAdmins";

export default {
    name: "ShowAdminsDes",
    components: {
        ShowAdmins
    },
}
</script>
